import React, { useState, useEffect } from "react";
import { Progress } from "antd";
import Collegue from "../dropdown/collegue ";
import KeyboardCall from "./keyboardCall";
import Navbar from "../dropdown/Navbar";
import Journal from "../dropdown/Journal";
import Contacts from "../dropdown/contacts";
function Home({
  navbar,
  closeBackHome,
  newcallClick,
  ConferenceCall,
  backHomeVariable,
}) {
  const [tap, setTap] = useState("phone");
  return (
    <div
      style={{
        position: "absolute",
        height: "95%",
        width: "100%",
        bottom: "0",
        borderRadius: "30px",
        backgroundColor: "white",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "40px",
          backgroundColor: "rgb(246 246 246)",
          borderRadius: "30px 30px 0px 0px",
        }}
      >
        <div
          style={{
            margin: "0px 44px",
            height: "100%",
            paddingTop: "6px",
            fontWeight: "500",
            color: "#545454",
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            {backHomeVariable === "conference" ? "Conférence" : "Nouvel appel"}
          </div>
          <div onClick={closeBackHome}>X</div>
        </div>
      </div>
      {tap === "phone" ? (
        <KeyboardCall
          callClick={
            backHomeVariable === "conference" ? ConferenceCall : newcallClick
          }
          //   callClickVideo={callClickVideo}
          navbar={navbar}
        />
      ) : tap === "logs" ? (
        <div>
          <Journal
            navbar={navbar}
            tabHeight={135}
            callClick={
              backHomeVariable === "conference" ? ConferenceCall : newcallClick
            }
            // token={token}
            // poste={poste}
            // callClick={callClick}
          />
        </div>
      ) : tap === "user" ? (
        <div>
          <Collegue
            callClick={
              backHomeVariable === "conference" ? ConferenceCall : newcallClick
            }
            // callClickVideo={callClickVideo}
            navbar={navbar}
            tabHeight={135}
            // token={token}
            // poste={poste}
          />
        </div>
      ) : tap === "contacts" ? (
        <div>
          <Contacts
            navbar={navbar}
            tabHeight={135}
            callClick={
              backHomeVariable === "conference" ? ConferenceCall : newcallClick
            }
          />
        </div>
      ) : null}

      <Navbar setTap={setTap} tap={tap} navbar={navbar} show={true} />
    </div>
  );
}

export default Home;
